import React, { useState, useEffect, use } from 'react';
import { usersRestaurant } from '../api/users';
import { Me } from '../api/users';
import { getAllCombo, getFoodName, createCombo, createFieldCombo, getAllFood, AddFoodForField, CreateFood, UploadFood, DeleteCombo } from '../api/food';
import { getAllFieldsCombo } from '../api/food';
import { getAllFoodFieldsCombo } from '../api/food';




const ComboAdmin = ({ token }) => {
    const [allCombo, setAllCombo] = useState([])
    const [allFieldsCombo, setAllFieldsCombo] = useState([])
    const [allFoodFieldsCombo, setAllFoodFieldsCombo] = useState([])
    // const [nameNewCombo, setNameCombo] = useState('')
    // const [minHoursNewCombo, setMinHoursCombo] = useState('')
    const [nameNewFieldCombo, setNameNewFieldCombo] = useState('')
    const [selectedCombo, setSelectedCombo] = useState('')
    const [selectedFood, setSelectedFood] = useState('')
    const [allFood, setAllFood] = useState([])
    const [reponseAddFoods, setResponseAddFoods] = useState({success: [], errors: []})

    const [fieldComboSelected, setFieldComboSelected] = useState('')
    const [newFood, setNewFood] = useState('')
    const [comboFields, setComboFields] = useState([])

    const [file, setFile] = useState()
    const [foodName, setFoodName] = useState()


    


    const loadAllCombo = async () => {
          try {
            const allCombo = await getAllCombo(token)
            setAllCombo(allCombo)

            const allFood = await getAllFood(token)
            setAllFood(allFood)
            let foods = {}
            for (let food of allFood){
                foods[food.id] = food.name
            }
            console.log(foods)
            setFoodName(foods)
              } catch (err) {
                console.error(err);
              }
          };
      
    useEffect(() => {
    
        loadAllCombo();
    }, [token]);
    
    async function selectCombo(e, comboId) {
        const data = await getAllFieldsCombo(token, comboId)
        setAllFieldsCombo(data)
        setSelectedCombo(comboId)
        setNameNewFieldCombo('')
  }

    async function selectField(e, fieldId) {
        const data = await getAllFoodFieldsCombo(token, fieldId)
        setFieldComboSelected(fieldId)
        for (const field in data) {
            const g = await getFoodName(token, data[field].food_id)
            data[field]['food_name'] = g.name
        }
        setAllFoodFieldsCombo(data)
    }

    // async function createNewCombo(e) {
    //     const newCombo = await createCombo(token, nameNewCombo, minHoursNewCombo)
    //     const allCombo = await getAllCombo(token)
    //     setAllCombo(allCombo)
    // }

    // async function createNewFieldCombo(e) {
    //     const newField = await createFieldCombo(token, selectedCombo, nameNewFieldCombo)
    //     const data = await getAllFieldsCombo(token, selectedCombo)
    //     setAllFieldsCombo(data)
    // }
    

    async function addFoodComboField(e) {
        const newFieldFood = await AddFoodForField(token, fieldComboSelected, selectedFood)
        const data = await getAllFoodFieldsCombo(token, fieldComboSelected)
        for (const field in data) {
            const g = await getFoodName(token, data[field].food_id)
            data[field]['food_name'] = g.name
        }
        setAllFoodFieldsCombo(data)
    }

    async function createNewFood(e) {
        const newName = await CreateFood(token, newFood)
    }
    
    async function addFile(event) {
        setFile(event.target.files[0])
    }

    async function sendFile(event) {
        const data = await UploadFood(token, file)
        setResponseAddFoods(data)
        console.log(data)

        // setStatusFile(data['errors'])
    }


    async function selectCombo(id){
        const data = await getAllFieldsCombo(token, id)
        console.log(data)
        let fields = []
        for (let field of data){
            const n = await getAllFoodFieldsCombo(token, field.id)

            fields.push({name: field.name, id: field.id, foods: n})
            for (let q of n){
                console.log(q)
            }
        }
        setComboFields(fields)
        setSelectedCombo(id)
    }

    async function deleteCombo() {
        const data = await DeleteCombo(token, selectedCombo)
        console.log(data)
        console.log(selectedCombo)
    }

    

    return (
        <div className="container">
            <div className="row">
                <div className="col-md-9">
                    <div className="accordion" id="accordionExample">
                        {/* {allCombo.map(combo => (
                            <div className={`accordion-item_${combo.id}`} key={combo.id}>
                                <h2 className="accordion-header">
                                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseOne_${combo.id}`} aria-expanded="true" aria-controls={`collapseOne_${combo.id}`} onClick={(e) => selectCombo(e.stopPropagation(), combo.id)}>
                                    {combo.name}
                                </button>
                                </h2>
                                <div id={`collapseOne_${combo.id}`} className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    
                                    {allFieldsCombo.map(field => (
                                        <button type="button" className="btn" data-bs-toggle="modal" data-bs-target="#exampleModal" key={field.id} onClick={(e) => selectField(e.stopPropagation(), field.id)}>
                                        {field.name}
                                        </button>
                                    ))}
                                    Название поля в комбо
                                    <input type="text" className="form-control" value={nameNewFieldCombo} key={combo.id}   onChange={(e) => setNameNewFieldCombo(e.target.value)} ></input>
                                    <button className='btn' onClick={createNewFieldCombo}>Создать</button>

                                    
                                </div>
                                </div>
                            </div>
                        ))} */}

                        {/* <div className="accordion-item">
                            <h2 className="accordion-header">
                            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                Создать новое комбо
                            </button>
                            </h2>
                            <div id="collapseOne" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                                Название нового комбо
                                <input type="text" className="form-control" value={nameNewCombo}   onChange={(e) => setNameCombo(e.target.value)} ></input>
                                Минимальное кол-во часов для комбо
                                <input type="text" className="form-control" value={minHoursNewCombo}   onChange={(e) => setMinHoursCombo(e.target.value)} ></input>
                                <button className='btn' onClick={createNewCombo}>Создать</button>
                            </div>
                            </div>
                        </div> */}

                        <div className="accordion-item">
                            <h2 className="accordion-header">
                            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne1" aria-expanded="true" aria-controls="collapseOne1">
                                Создать еду
                            </button>
                            </h2>
                            <div id="collapseOne1" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                                Название новой еды
                                <input type="text" className="form-control" value={newFood}   onChange={(e) => setNewFood(e.target.value)} ></input>
                                <button className='btn' onClick={createNewFood}>Создать</button>
                            </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="col-md-3">
                    Добавить еду
                    <div className="form" style={{marginTop: "5%"}}>
                        <input className="form-control" type="file" id="formFile" onChange={addFile}></input>
                        <button className="btn" onClick={sendFile} style={{marginTop: "5%"}}>Отправить</button>
                    </div>
                </div>
                <div className="col-md-12">
                    <table className='table table-bordered'>
                        <thead>
                            <tr>
                                <th>id</th>
                                <th>Имя</th>
                                <th>Минимальное кол-во часов</th>
                                <th>Опубликовано</th>
                            </tr>
                        </thead>
                        <tbody>
                            {allCombo.map(combo => (
                                <tr style={{cursor: "pointer"}} data-bs-toggle="modal" data-bs-target="#modalFood" onClick={(e) => {e.stopPropagation(); selectCombo(combo.id)}}>
                                    <td>{combo.id}</td>
                                    <td>{combo.name}</td>
                                    <td>{combo.min_hours}</td>
                                    <td>{typeof combo.active === 'boolean' ? String(combo.active) : combo.active}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                <h3>Успешные</h3>
                <table className='table table-bordered'>
                    <thead>
                        <tr>
                            <th>Имя</th>
                            <th>C код</th>
                        </tr>
                    </thead>
                    <tbody>
                        {reponseAddFoods.success.map(food => (
                            <tr style={{cursor: "pointer"}}>
                                <td>{food.name}</td>
                                <td>{food.c_code}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="col-md-6">
                <h3>Проблемные</h3>
                <table className='table table-bordered'>
                    <thead>
                        <tr>
                            <th>Имя</th>
                            <th>C код</th>
                            <th>Проблема</th>
                        </tr>
                    </thead>
                    <tbody>
                        {reponseAddFoods.errors.map(food => (
                            <tr style={{cursor: "pointer"}}>
                                <td>{food.name}</td>
                                <td>{food.c_code}</td>
                                <td>{food.message}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            </div>
            
            <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="exampleModalLabel">Заголовок модального окна</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Закрыть"></button>
                    </div>
                    <div className="modal-body">
                        {allFoodFieldsCombo.map(ff => (
                            <p>{ff.food_name}</p>
                        ))}
                        <select className="form-select" defaultValue={0} aria-label="Default select example" onChange={ (e) => setSelectedFood(e.target.value) }>
                            <option value="0" >Выберите еду для добавления в это поля</option>
                            {allFood.map(food => (
                              <option key={food.id} value={food.id}>{food.name}</option>
                            ) ) }
                        </select>
                        <button type="button" className="btn" onClick={addFoodComboField}>Добавить</button>
                    </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="modalFood" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="exampleModalLabel">Заголовок модального окна</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Закрыть"></button>
                    </div>
                    <div className="modal-body">
                        {comboFields.map(field => (
                            <div className="field" key={field.field_id}>
                            <p>{field.name}</p>
                            <ul className='list-group'>
                                {field.foods.map(food => (
                                    <li className='list-group-item' key={food.food_id} value={food.food_id}>
                                        {foodName[food.food_id]}
                                    </li>
                                ))}
                            </ul>
                            {/* <select name="" id="" className='form-select'>
                                {field.foods.map(food => (
                                <option key={food.food_id} value={food.food_id}>
                                    {foodName[food.food_id]}
                                </option>
                                ))}
                            </select> */}
                            </div>
                        ))}
                        <div className="btn" onClick={deleteCombo}>Удалить</div>
                    </div>
                    {/* <div className="modal-body">
                        {allFoodFieldsCombo.map(ff => (
                            <p>{ff.food_name}</p>
                        ))}
                        <select className="form-select" defaultValue={0} aria-label="Default select example" onChange={ (e) => setSelectedFood(e.target.value) }>
                            <option value="0" >Выберите еду для добавления в это поля</option>
                            {allFood.map(food => (
                              <option key={food.id} value={food.id}>{food.name}</option>
                            ) ) }
                        </select>
                        <button type="button" className="btn" onClick={addFoodComboField}>Добавить</button>
                    </div> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ComboAdmin